export default "__VITE_ASSET__GeHXuFm8__"